module.exports = __webpack_public_path__ + "static/media/HCMM733.522e96c8.jpg";